<template>
  <Toast ref="toast" />
  <div class="page-container" style="min-height: auto;">
    <div class="page-title-container">
      <h1 class="title-text">Admin Dashboard</h1>
    </div>

    <div class="center-items">
      <button class="primary-button" style="margin-right: 1rem;" @click="$router.push({ path: '/admin-create-site' })">
        ➕ Create Sites
      </button>
      <button class="tertiary-button" @click="$router.push({ path: '/admin-suggested-sites' })">
        💡 Suggested Sites
      </button>
    </div>

    <div div class="center-items">
      <select class="input-container" v-model="option" @change="getJobs()">
        <option value="unableToComplete">Unable to complete</option>
        <option value="pending">Pending</option>
        <option value="completed">Completed</option>
        <option value="all">All</option>
      </select>
    </div>

    <h2 v-if="jobs.length === 0">No {{ option }} found</h2>

    <div v-for="(job, index) in paginatedJobs" :key="`job-${index}`">
      <div class="feature admin-dashboard-container" style="background-color: var(--secondary-color);">
        <div>
          <b>📍 Status: {{ job.state }}</b>
        </div>
        <div>
          <img v-if="job.hasCompanyLogo" class="image-hero" :src="job.logoUrl" />
        </div>
        <button
          class="secondary-button small-button"
          style="margin-top: 1rem;"
          @click="$router.push({ path: `/admin-job-detail/${job.id}` })"
        >
          Job Offer Details
        </button>
      </div>

      <div class="feature admin-dashboard-container">
        <b>ID</b>
        <div>{{ job.id }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>userId</b>
        <div>{{ job.userId }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>jobTitle</b>
        <div>{{ job.jobTitle }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>jobDescription</b>
        <div>{{ job.jobDescription }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>salaryStart</b>
        <div>{{ job.salaryStart }}{{ job.currency }}</div>
        <b>salaryEnd</b>
        <div>{{ job.salaryEnd }}{{ job.currency }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>email</b>
        <div>{{ job.email }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>companyWebsite</b>
        <div>{{ job.companyWebsite }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>companyName</b>
        <div>{{ job.companyName }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>createdAt</b>
        <div>{{ job.createdAt.toDate().toDateString() }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>user ID</b>
        <div>{{ job.userId }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>userEmail</b>
        <div>{{ job.useEmail }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>applyEmail</b>
        <div>{{ job.applyEmail }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>applyWebsite</b>
        <div>{{ job.applyWebsite }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>contractType</b>
        <div>{{ job.contractType }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>location</b>
        <div>{{ job.location }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>hasCompanyLogo</b>
        <div>{{ job.hasCompanyLogo }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>isFullRemote</b>
        <div>{{ job.isFullRemote }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>userEmail</b>
        <div>{{ job.userEmail }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>userEmailVerified</b>
        <div>{{ job.userEmailVerified }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>pendingJobSitesCount</b>
        <div>{{ job.pendingJobSites.length }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>completedJobSitesCount</b>
        <div>{{ job.completedJobSites.length }}</div>
      </div>
      <div class="feature admin-dashboard-container">
        <b>unableToCompleteCount</b>
        <div>{{ job.unableToCompleteSites.length }}</div>
      </div>
      <hr />
    </div>

    <div class="pagination-container">
      <button v-if="currentPage !== 0" @click="previous()" class="secondary-button small-button pagination-button">
        <i class="fas fa-arrow-left previous-page-button-icon"></i> Previous
      </button>
      <button v-if="m()" @click="next()" class="secondary-button small-button">
        Next <i class="fas fa-arrow-right next-page-button-icon"></i>
      </button>
    </div>
  </div>
</template>

<script>
import firebase from "@/firebase";
import utils from "@/utils";

import Toast from "@/components/Toast";

export default {
  mounted() {
    this.getJobs();
  },

  components: {
    Toast,
  },

  created() {
    window.scrollTo(0, 0);
  },

  data() {
    return {
      jobs: [],
      option: "pending",
      currentPage: 0,
      itemsPerPage: 10,
      user: firebase.auth.currentUser,
    };
  },

  computed: {
    paginatedJobs() {
      return this.jobs.slice(this.currentPage * this.itemsPerPage, this.currentPage * this.itemsPerPage + this.itemsPerPage);
    },
  },

  methods: {
    m() {
      const maxPages = Math.trunc(this.jobs.length / this.itemsPerPage);
      return this.currentPage + 1 < maxPages;
    },
    next() {
      this.currentPage++;
      window.scrollTo(0, 0);
    },
    previous() {
      this.currentPage--;
      window.scrollTo(0, 0);
    },

    getJobs() {
      const Paddle = window.Paddle;
      Paddle.Spinner.show();

      let promise = firebase.firestore.collection("jobs");

      if (this.option !== "all") {
        promise = promise.where("state", "==", this.option);
      }

      promise
        .get()
        .then(async (s) => {
          this.jobs = [];
          for (const doc of s.docs) {
            const job = doc.data();
            job.id = doc.id;

            const pendingJobSitesSnap = await firebase.firestore
              .collection("job-site")
              .where("jobId", "==", job.id)
              .where("state", "==", "pending")
              .get();

            const completedJobSitesSnap = await firebase.firestore
              .collection("job-site")
              .where("jobId", "==", job.id)
              .where("state", "==", "completed")
              .get();

            const unableToCompleteSitesSnap = await firebase.firestore
              .collection("job-site")
              .where("jobId", "==", job.id)
              .where("state", "==", "unableToComplete")
              .get();

            job.pendingJobSites = pendingJobSitesSnap.docs;
            job.completedJobSites = completedJobSitesSnap.docs;
            job.unableToCompleteSites = unableToCompleteSitesSnap.docs;

            if (job.hasCompanyLogo) {
              job.logoUrl = await utils.getUrlFromPath(`images/company-post-logos/${job.id}.png`);
            }
            this.jobs.push(job);
          }
        })
        .catch((e) => {
          this.$refs.toast.text = e.message;
          this.$refs.toast.show();
          console.error(e);
        })
        .finally(() => Paddle.Spinner.hide());
    },
  },
};
</script>

<style scoped>
.image-hero {
  max-width: 100px;
  max-height: 100px;
}
</style>
